import config from '../config/environment';
import supabase from '../config/supabase';
import { WorkoutAssignmentService } from './WorkoutAssignmentService';

function extractSummaryText(body: unknown): string {
  if (!body || typeof body !== 'object' || Array.isArray(body)) {
    return '';
  }

  const record = body as Record<string, unknown>;
  const directKeys = [
    'summary',
    'Summary',
    'output',
    'Output',
    'text',
    'Text',
    'result',
    'Result',
    'content',
    'Content',
  ] as const;

  for (const key of directKeys) {
    const value = record[key];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  const output = record.output;
  if (Array.isArray(output)) {
    for (const item of output) {
      if (!item || typeof item !== 'object' || Array.isArray(item)) {
        continue;
      }

      const content = (item as Record<string, unknown>).content;
      if (!Array.isArray(content)) {
        continue;
      }

      for (const part of content) {
        if (!part || typeof part !== 'object' || Array.isArray(part)) {
          continue;
        }

        const text = (part as Record<string, unknown>).text;
        if (typeof text === 'string' && text.trim()) {
          return text.trim();
        }
      }
    }
  }

  return '';
}

class StudentNoteSummaryServiceClass {
  async generate(studentId: number): Promise<string> {
    if (!Number.isInteger(studentId) || studentId <= 0) {
      throw new Error('Aluna inválida para gerar o resumo das observações.');
    }

    const { data: sessionData } = await supabase.auth.getSession();
    const token = sessionData?.session?.access_token;

    if (!token) {
      throw new Error('Usuária não autenticada. Faça login novamente.');
    }

    const response = await fetch(`${config.supabaseFunctionsUrl}/IAServices`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        apikey: config.supabaseAnonKey,
      },
      body: JSON.stringify({
        AIEventType: 0,
        Input: `Faça o resumo das observações da aluna ${studentId}`,
        Title: `Resumo das observações aluna ${studentId}`,
      }),
    });

    const body = await response.json().catch(() => ({} as Record<string, unknown>));
    if (!response.ok || body?.success === false) {
      throw new Error(
        (typeof body?.error === 'string' && body.error)
          || 'Não foi possível gerar o resumo das observações.',
      );
    }

    const fromResponse = extractSummaryText(body);
    if (fromResponse) {
      return fromResponse;
    }

    const { summary } = await WorkoutAssignmentService.listStudentNotes(studentId);
    const fromStore = typeof summary === 'string' ? summary.trim() : '';
    if (fromStore) {
      return fromStore;
    }

    throw new Error('Não foi possível gerar o resumo das observações.');
  }
}

export const StudentNoteSummaryService = new StudentNoteSummaryServiceClass();
